<div class="form-container">
  <div class="header-container">
    <div class="name-container">
      @if (showChevron) {
        <div (click)="onToggleDocumentChangeState()">
          <i
            class="icon ic-chevron-down-20"
            [class]="{ 'chevron-up': !change.expanded }"
          ></i>
        </div>
      }
      <div class="name">
        <span class="font-weight-normal">{{ change.type | documentType | uppercase }}:</span>
        {{ change.description }}
      </div>
    </div>

    <div class="d-flex gap-12">
      <button
        type="button"
        class="bg-transparent border-0 p-1"
        (click)="onDownloadPreview()"
      >
        <i class="icon ic-download-20"></i>
      </button>

      <button
        type="button"
        class="bg-transparent border-0 p-1"
        [hidden]="hideEdit"
        (click)="onEditDocumentChange()"
      >
        <i class="icon ic-form-edit-20"></i>
      </button>
    </div>

  </div>
  @if (change.expanded) {
    <div class="company-info-container">
      @for (dic of change.preview; track dic) {
        @if (dic.key === 'divider') {
          <app-divider></app-divider>
        } @else if (dic.key === 'empty line') {
          <div class="empty-line"></div>
        } @else {
          <div class="info-row">
            <div class="title">{{ dic.key }}</div>
            <div class="value" [innerHTML]="dic.value"></div>
          </div>
        }
      }
    </div>
  }
</div>
